import "./subscriptionList.css";
import moment from "moment";

const SubscriptionsList = ({
  listData,
  handleOnClick
}) => {

  const rowsPerPage = 10;
  const emptyRows = Array.from(
    { length: Math.max(0, rowsPerPage - listData.length) },
    (_, index) => index
  );

  return (
    <div className="mt-4 subscriptionList">
      <table className="table table-bordered table-hover">
        <thead className="headingTable">
          <tr>
            <th className="text-center fs-6">Sub. ID</th>
            <th className="text-center fs-6">Craver Name</th>
            <th className="text-center fs-6">Items</th>
            <th className="text-center fs-6">Phone Number</th>
            <th className="text-center fs-6">MenuType</th>
            <th className="text-center fs-6">Selected Plan</th>
            <th className="text-center fs-6">Start Date - End Date</th>
            <th className="text-center fs-6">Serviceable Days</th>
            <th className="text-center fs-6">Paused Days</th>
          </tr>
        </thead>
        <tbody className="tableData">
          {listData?.map((order) => {
            return (
              <tr
                className="rowOrderData"
                key={order.subscriptionID}
                onClick={() => handleOnClick(order)}
              >
                <td className="text-center fs-6">
                  {order.subscriptionID.slice(0, -4)}
                  <strong>{order.subscriptionID.slice(-4)}</strong>
                </td>
                <td className="text-center fs-6">
                  {order.craverDetails.craverName}
                </td>
                <td className="fs-6">
                  {order.orderedItems?.map((item, index) => (
                    <div key={index}>
                      {item.quantity} - {item.menuName}{'\n'}<strong>{item.itemType}</strong>
                    </div>
                  ))}
                </td>
                <td className="text-center fs-6">
                  {order.craverDetails.craverMobile}
                </td>
                <td className="text-center fs-6">{order.menuType}</td>
                <td className="text-center fs-6">{order.subscriptionType}</td>
                <td className="text-center fs-6">
                  {order.startDate} - {order.endDate}
                </td>
                <td className="text-center fs-6">
                  {order.serviceableDays?.map((day) => ["S", "M", "T", "W", "Th", "F", "S"][day])?.join(", ")}
                </td>
                <td className="text-center fs-6">
                  {order.pausedDays?.join(", ")}
                </td>
              </tr>
            );
          })}
          {emptyRows.map((_, index) => (
            <tr key={`empty-${index}`} style={{ height: "3rem" }}>
              <td colSpan={9}></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubscriptionsList;
